import { Record } from 'immutable';

const UpdateQuoteModelV25 = Record({
    leadId: 0,
    accountId: 0,
    vehicleCondition: '',
    saleType: 'retail',
    taxPlan: 'standard',
    purchaseMethod: 'cash',
    financePlan: '',
    kmPerYearPlan: 0,
    paymentFrequency: 12,
    term: 0,
    cashDown: 0,
    tradeIn: 0,
    lien: 0,
    transactionToken: '',
    id: '',
    quoteRevision: '',
});

export default UpdateQuoteModelV25;
